import SEOHead from '../../components/SEOHead';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Problem from './components/Problem';
import Solution from './components/Solution';
import HowItWorks from './components/HowItWorks';
import Features from './components/Features';
import HospitalExplorer from './components/HospitalExplorer';
import PregnancyTracker from './components/PregnancyTracker';
import PostCare from './components/PostCare';
import Trust from './components/Trust';
import WhoIsItFor from './components/WhoIsItFor';
import FinalCTA from './components/FinalCTA';
import MapView from './components/MapView';
import CostCalculator from './components/CostCalculator';
import Insights from './components/Insights';
import Contact from './components/Contact';
import Creator from './components/Creator';
import Footer from './components/Footer';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://momsfirstcare.com';

  const schema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "MomsFirstCare",
    "url": siteUrl,
    "description": "One platform for pregnancy and baby care — from first week to 5 years. Track pregnancy, find hospitals, and never miss a vaccine.",
    "publisher": {
      "@type": "Organization",
      "name": "MomsFirstCare"
    }
  };

  return (
    <>
      <SEOHead
        title="MomsFirstCare — Pregnancy & Baby Care Platform | Pune Hospitals"
        description="Track your pregnancy week by week, find the right hospitals in Pune, and manage baby vaccines from 0–5 years. One trusted platform for complete maternal and child care."
        keywords="pregnancy tracker Pune, baby vaccine schedule, maternity hospital Pune, maternal care platform, MomsFirstCare"
        canonical={siteUrl}
        schema={schema}
      />
      <div className="min-h-screen bg-white">
        <Navbar />
        <Hero />
        <Problem />
        <Solution />
        <HowItWorks />
        <Features />
        <HospitalExplorer />
        <PregnancyTracker />
        <CostCalculator />
        <MapView />
        <Insights />
        <PostCare />
        <Trust />
        <WhoIsItFor />
        <FinalCTA />
        <Creator />
        <Contact />
        <Footer />
      </div>
    </>
  );
}
